export default function SubmitBanner() {
  return (
    <section id="submit" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20dark%20stage%20with%20warm%20amber%20and%20crimson%20glow%2C%20long%20spotlight%20beams%20and%20haze%2C%20cinematic%20atmospheric%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=1400&height=520&seq=hlcg-submit-banner-01&orientation=landscape"
            alt="投稿爆料与下载吃瓜客户端"
            title="黑料吃瓜 投稿爆料入口"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>

          <div className="relative flex flex-col gap-6 px-5 py-10 md:flex-row md:items-center md:justify-between md:px-10 md:py-14">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-shield-check-line text-accent-400"></i>
                匿名投稿 · 全程加密
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-white md:text-3xl">
                你手里那条线索
                <br className="hidden md:block" />
                可能就是明天的大瓜
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-200">
                上传截图、录音或视频，交给吃瓜小组核实比对。投稿可选择匿名，我们只在意事情本身。
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row md:shrink-0">
              <a
                href="#submit"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                <i className="ri-upload-cloud-2-line text-lg"></i>
                立即匿名投稿
              </a>
              <a
                href="#submit"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 bg-white/10 px-5 py-3 text-sm font-medium text-white backdrop-blur hover:bg-white/20"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载吃瓜客户端
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}